import { QaSpecBoolean } from 'pages/qa-spec/components/shared/QaSpecBoolean';

import { transformBooleanToStringQaSpecValue } from 'pages/qa-spec/utils/transformQaBooleanValue';

export const RadioBooleanRender = (props) => {
  const { value } = props;

  return (
    <div
      style={{
        pointerEvents: 'none',
        paddingTop: 6,
        paddingLeft: 8,
      }}
    >
      <QaSpecBoolean value={transformBooleanToStringQaSpecValue(value)} />
    </div>
  );
};
